export default __webpack_public_path__ + "static/media/AWS.49ac3a59.svg";